module.exports = __webpack_public_path__ + "img/751344.c6fd809e.jpg";